import { RichTextBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpRichTextBlock } from './AmpRichTextBlock';
import { RichTextBlock } from './RichTextBlock';

export const RichTextBlockMapping: BlockMapping<RichTextBlockData> = {
  invariant: [
    {
      prop: 'html',
      msg: 'Html data required for rich text',
    },
  ],
  width: 'INSET',
  Component: RichTextBlock,
  AmpComponent: AmpRichTextBlock,
};
